export const ROOM_TRACKS_TTL_MS = 4000;
export const ROOM_TRACKS_CLEANUP_INTERVAL_MS = 200;
export const CLEANUP_ROOM_TRACKS_MAX_ATTEMPTS =
	Math.ceil(ROOM_TRACKS_TTL_MS / ROOM_TRACKS_CLEANUP_INTERVAL_MS) + 2; // Extra two attempts to ensure old tracks are picked up.
/* Self publishing transmissions can only last 20 seconds. */
export const SELF_PUBLISH_TRANSMISSION_TTL_MS = 20000;
export const REPLY_TRACK_PREFIX = "reply-";
export const MAX_ROOM_TRANSMISSION_CARDS_SHOWN = 5;
export const DM_MEDIA_ROOM_SEPERATOR = "_";
